function getBaseURL(isBff) {
  var bff = isBff === undefined ? true : isBff;

  const mainUrl = location.host;

  if (bff) {
    const url = mainUrl.replace('portal', '');
    const exp = new RegExp('^[d|h]', 'i');
    const separador = exp.test(url) ? '-' : '';
    return `${location.protocol}//bffportal${separador}${url}`;
  }

  return `${location.protocol}//${mainUrl}`;
}

// example de url
// ?linkId=2C9201F3776914FE01776982CE1B0B52&actId=2C9201F3776914FE01776982CE1B0B52

// fazer fetch assim que a pagina abrir para a ativacao do usuario
// /portal/portal-vr/login/ativar-usuario.html?actId=2C92023A67856AB001682D88DC1B73E6

export async function activeUser(actId) {
  const url = `${getBaseURL(false)}/portal/portal-vr/login/ativar-usuario.html?actid=${actId}`;

  fetch(url, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
  })
  .then(resp => {
    console.log(resp)
  })
  .catch((err) => {
    console.info(err);
  });
}



/**
 *
 * @param {*} data
 * {
    "idLinkDesbloqueio" : "2C9201F3776914FE01776982CE1B0B52",
    "novaSenha" : "novaSenhaTeste2020",
    "confirmaNovaSenha" : "novaSenhaTeste2020"
  }
 */
export async function changePassword(data = {}) {
  const url = `${getBaseURL()}/api-web/ec/onboarding/onboarding/usuario/senha`;

  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  });

  return new Promise(async (resolve, reject) => {
    if (!response.ok) {
      const error = await response.json();

      reject(error)
    } else {
      resolve(response.json());
    }
  });
}
